import type { InjectionKey } from 'vue';
import { DB_TYPE } from '@/common/define/common.define';
import type { DBType } from '@/common/utils/types';
import type { BreadCrumbMenuInfo } from './breadCrumbs.types';

export const BREAD_CRUMBS_MODAL_CLASS = 'route-paths-modal';

export const BREAD_CRUMBS_CHANGE_FAVORITE_KEY = Symbol(
  'BREAD_CRUMBS_CHANGE_FAVORITE_KEY',
) as InjectionKey<(data: BreadCrumbMenuInfo) => Promise<void>>;

export const DASHBOARD_MENU_TYPE = {
  DASHBOARD: 'dashboard',
  ANALYSIS_DASHBOARD: 'analysisBoard',
};

// breadCrumbs 에서 부모 텍스트 표시 필요한 메뉴 값
export const SHOW_PARENT_TEXT_VALUES = ['pa_kubernetes', 'pa_faultAnalysis'];

export const CLUSTER_VIEW_TYPE: DBType[] = [DB_TYPE.SINGLESTORE];
